module.exports = "/images/vg.svg?e0c7030e18f31854dc805c6c67f3a0ad";